// extracted by mini-css-extract-plugin
export default {"statusWrapper":"Row_statusWrapper__xKIAG","statusName":"Row_statusName__1kxrO","statusIcon":"Row_statusIcon__R-+qr","linkToProfile":"Row_linkToProfile__6Pmsr"};